module.exports = __webpack_public_path__ + "static/body-background-806a86766eee0ca2c53cd7ad4982cad0.jpg";